import * as React from "react";

export const Success = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.64141 7.99999C2.64141 5.01766 5.05907 2.59999 8.04141 2.59999C8.91487 2.59999 9.73828 2.80693 10.4669 3.1739C10.7628 3.32297 11.1236 3.20389 11.2726 2.90794C11.4217 2.61199 11.3026 2.25123 11.0067 2.10217C10.1145 1.65278 9.10658 1.39999 8.04141 1.39999C4.39633 1.39999 1.44141 4.35491 1.44141 7.99999C1.44141 11.6451 4.39633 14.6 8.04141 14.6C11.3123 14.6 14.0264 12.2212 14.5502 9.09927C14.605 8.77246 14.3845 8.46309 14.0577 8.40826C13.7309 8.35344 13.4215 8.57392 13.3667 8.90072C12.9383 11.4542 10.7165 13.4 8.04141 13.4C5.05907 13.4 2.64141 10.9823 2.64141 7.99999ZM13.4606 5.42926C13.6977 5.19774 13.7022 4.81787 13.4707 4.58079C13.2392 4.34371 12.8593 4.33921 12.6222 4.57073L7.92141 9.16135L5.46061 6.75823C5.22353 6.52671 4.84366 6.53121 4.61214 6.76829C4.38062 7.00537 4.38513 7.38524 4.6222 7.61676L7.5022 10.4293L7.92141 10.8386L8.34061 10.4293L13.4606 5.42926Z"
    />
);

export const SuccessSmall = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2681 5.5851C11.5024 5.81941 11.5024 6.19931 11.2681 6.43363L7.28681 10.4149C7.17429 10.5274 7.02167 10.5907 6.86255 10.5907C6.70341 10.5907 6.5508 10.5274 6.43828 10.4149L4.73201 8.70865C4.4977 8.47434 4.4977 8.09444 4.73201 7.86013C4.96632 7.62581 5.34622 7.62581 5.58054 7.86013L6.86255 9.14213L10.4196 5.5851C10.6539 5.35078 11.0338 5.35078 11.2681 5.5851Z"
    />
);
